export { default as api } from '../../api'
export * as dateHelpers from './date'
export * as validation from '../validation'
export const REVALIDATE_TIME_10_MINUTES = 600000

export const testFunction = () => {
  console.log('Hi from common')
}
